import script from "./search-page-empty-state.vue?vue&type=script&setup=true&lang=js"
export * from "./search-page-empty-state.vue?vue&type=script&setup=true&lang=js"

import "./search-page-empty-state.vue?vue&type=style&index=0&id=0b6b478d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b6b478d"]])

export default __exports__